import { createFileRoute, Link } from "@tanstack/react-router";
import { DashboardHeader } from "@/components/DashboardHeader";
import { ClinicalPageShell } from "@/components/clinical";
import { AccountPlanCard } from "@/components/settings/AccountPlanCard";
import { UsageGaugesPanel } from "@/components/settings/UsageGaugesPanel";
import { UserProfileCard } from "@/components/settings/UserProfileCard";
import { PickingDevicesCard } from "@/components/settings/PickingDevicesCard";
import { KycVerificationCard } from "@/components/settings/KycVerificationCard";
import { useTenantContext } from "@/lib/tenant-context";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/app/cuenta")({
  component: CuentaPage,
  head: () => ({ meta: [{ title: "Mi perfil — Structura Market" }] }),
});

function CuentaPage() {
  const { userRole, productFlags } = useTenantContext();
  const isOwner = userRole === "owner" || userRole === "super_admin";
  const pickingEnabled = productFlags.picking_app === true;
  const legalKycEnabled = productFlags.legal_kyc_gate === true;

  return (
    <div>
      <DashboardHeader
        title="Mi perfil"
        subtitle="Tu cuenta, preferencias y, si sos administrador, plan y consumos"
        layout="sticky"
      />
      <ClinicalPageShell>
        <div className="mx-auto max-w-3xl space-y-8">
          <section id="cuenta" className="space-y-3">
            <h3 className="text-sm font-semibold text-foreground">Datos de la cuenta</h3>
            <UserProfileCard />
          </section>

          {pickingEnabled ? (
            <section id="dispositivos" className="space-y-3">
              <h3 className="text-sm font-semibold text-foreground">Dispositivos</h3>
              <PickingDevicesCard />
            </section>
          ) : null}

          {isOwner ? (
            <>
              <section id="suscripcion" className="space-y-3">
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <h3 className="text-sm font-semibold text-foreground">Suscripción</h3>
                  <Button asChild size="sm" variant="outline">
                    <Link to="/app/suscripcion">Cambiar plan / cancelar</Link>
                  </Button>
                </div>
                <AccountPlanCard />
              </section>

              <section id="uso" className="space-y-3">
                <h3 className="text-sm font-semibold text-foreground">Consumos</h3>
                <UsageGaugesPanel variant="dashboard" />
              </section>

              <section id="packs" className="space-y-3">
                <h3 className="text-sm font-semibold text-foreground">Packs adicionales</h3>
                <UsageGaugesPanel variant="packs" />
              </section>

              {legalKycEnabled ? (
                <section id="legal-kyc" className="space-y-3">
                  <div className="flex flex-wrap items-center justify-between gap-2">
                    <h3 className="text-sm font-semibold text-foreground">Legal y verificación</h3>
                    <Button asChild size="sm" variant="outline">
                      <Link to={"/app/settings/legal" as never}>Ver documentos e historial</Link>
                    </Button>
                  </div>
                  <KycVerificationCard />
                </section>
              ) : null}
            </>
          ) : null}
        </div>
      </ClinicalPageShell>
    </div>
  );
}
